import React from 'react'
import cx from 'classnames'

import { Field } from './common/Field/Field'

import styles from './Form.module.scss'

type FormProps = {
  children?: React.ReactNode
  className?: string
}

type FormComponent = ((props: FormProps) => React.JSX.Element) & {
  Field: typeof Field
}

export const Form: FormComponent = Object.assign(
  ({ children, className }: FormProps) => (
    <form className={cx(styles.form, className)}>{children}</form>
  ),
  {
    Field,
  },
)
